<template>
  <div>
    <md-dialog :md-active.sync="showDialogEdit">
      <md-dialog-title>{{labels.information}}</md-dialog-title>
      <md-dialog-content>
        <b-col md="8" lg="12" class="p-4 mx-auto">
          <b-form-group @submit.prevent="editInfoUser">
            <label>{{labels.name}} </label>
            <md-field>
              <md-input type="text" v-model="Item.nombre"></md-input>
            </md-field><br>

            <label>{{labels.description}}</label>
            <md-field>
                <md-textarea v-model="Item.descripcion" md-autogrow></md-textarea>
            </md-field>
          </b-form-group>
          <md-dialog-actions>
            <md-button class="md-primary" @click="editInfoUser(Item)">Guardar</md-button>
            <md-button class="md-accent" @click="showDialogEdit = false">Cerrar</md-button>
          </md-dialog-actions>
        </b-col>
      </md-dialog-content>
    </md-dialog>
  </div>
</template>

<script>
import Rol from "@/services/Roles";
export default {
    props:['showDialogEdit','Item'],
    data(){
        return{
            isLoading:false,
            // showDialogEdit:false,
            Prueba:{
                nombre:'',
                description:'',
            },
        }
    },
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                information: "Información del Rol",
                name: "Nombre",
                description: "Descripción",
                }
            }else {
                return {
                information: "Role information",
                name: "Name",
                description: "Description",
                }
            }
        }
    },
    methods:{
        editInfoUser(Item){
            // console.log(Item)
            // this.isLoading = true;
            Rol.updateRolById(Item.id, Item.nombre, Item.descripcion)
            
                .then(() => {
                  // console.log(rta+'---')
                  this.isLoading = true;
                  // this.roles = rta.data.roles;
                  this.$toast.success("Rol editado correctamente")
                  location. reload()
                })
                .catch(() => {
                // console.log(error);
                this.error = true;
                })
                .finally(() => {
                this.isLoading = false;
            });
        }
    }
}
</script>